import type { AttachmentWellViewState } from 'owa-attachment-well-data';
import { logUsage } from 'owa-analytics';

let registeredCallback:
    | ((conversationId: string, itemId: string) => AttachmentWellViewState | null)
    | null = null;

const getAttachmentWellViewStateByItemIdHelper = {
    register: (
        callback: (conversationId: string, itemId: string) => AttachmentWellViewState | null
    ): void => {
        registeredCallback = callback;
    },
    available: (): boolean => !!registeredCallback,
    run: (conversationId: string, itemId: string): AttachmentWellViewState | null => {
        if (registeredCallback) {
            return registeredCallback(conversationId, itemId);
        } else {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logUsage('CnexErrorAttachmentWellGetterNotRegistered', undefined);
            return null;
        }
    },
};

export { getAttachmentWellViewStateByItemIdHelper };
